import { render, staticRenderFns } from "./TrTestMultiCheckboxImprV2.vue?vue&type=template&id=61230c02&scoped=true&"
import script from "./TrTestMultiCheckboxImprV2.vue?vue&type=script&lang=js&"
export * from "./TrTestMultiCheckboxImprV2.vue?vue&type=script&lang=js&"
import style0 from "./TrTestMultiCheckboxImprV2.vue?vue&type=style&index=0&id=61230c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61230c02",
  null
  
)

export default component.exports